import { execAdmin } from '@src/apis/reware/utils';
import { RewareAdminTypes } from '@troverecommerce/shared-reware-api';

export interface UserRoleForPartner {
  code: string;
  name: string;
  partnerCodes: string[];
}

export const fetchUserRoles = async (uuid: string): Promise<UserRoleForPartner[]> => {
  const query = `
    query fetchUserRoles(
      $shouldLimitForEditing: Boolean!
      $filters: UserFiltersInputTypeAdmin
    ) {
      users(
        shouldLimitForEditing: $shouldLimitForEditing
        filters: $filters
      ) {
        rows {
          roles {
            roleCode
            name
            partnerCodes
          }
        }
      }
    }
  `;

  interface UsersResponse {
    users: RewareAdminTypes.PagedUserTypeAdmin;
  }

  const data = await execAdmin<
    { shouldLimitForEditing: boolean, filters: RewareAdminTypes.UserFiltersInputTypeAdmin },
    UsersResponse
  >(query, {
    variables: {
      shouldLimitForEditing: false,
      filters: { uuid },
    },
  });

  const roles = data.users.rows?.[0]?.roles || [];
  return roles
    .filter((r): r is RewareAdminTypes.UserRolePartnersTypeAdmin => r !== null)
    .map(r => ({
      code: r.roleCode || '',
      name: r.name || '',
      partnerCodes: (r.partnerCodes || []).filter((p): p is string => p !== null),
    }));
};
